import { isCustomerFeatureEnabled } from 'src/data/customer';
import { BE_CUSTOMER_FEATURES } from 'src/lib/featureFlags';

import { useCurrentCustomer } from './useCurrentCustomer';

export const useCustomerTwitterSocialIntegrationEnabled = () => {
  const customer = useCurrentCustomer();

  return isCustomerFeatureEnabled(customer, BE_CUSTOMER_FEATURES.twitterSocialIntegrationEnabled);
};
